<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
			<div class="row" >
				<img src="../../assets/img/khalBanner.png" style="width: 100%;" />
			</div>
			<div class="mfty-box" style="background-color: #f0f0f0;height: 600px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					客户案例
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0fbee7;"></div>
				</div>
				<div style="width: 1100px;margin: 0 auto;">
					<div class="row" style="margin-top: 40px;">
						<div class="col">
							<div class="item-no" style="color: #000;font-size: 18px;">
								Maob-MES
							</div>
							<div class="item-no" style="color: #000;font-size: 22px;margin-top: 15px;">
								上海米诺测量仪表Maob-MES设备管理成功导入
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;margin-top: 25px;line-height: 24px;text-align: left;">
								米诺是真诺测量仪表（上海）有限公司的品牌。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;margin-top: 25px;line-height: 24px;text-align: left;">
								真诺测量仪表（上海）有限公司成立于2000年，是德国米诺真兰集团在亚洲地区的第一家全资子公司。作为大中华地区总部，专业研发、生产水表、热量表等精密在线测量仪表，每年数百万只的水表和热量表行销全球各地。公司秉承一百多年仪表制造经验的德国米诺真兰仪表公司的先进技术和质量管理理念，传承享誉世界的德国仪表制造工艺，倾力为广大客户打造一流的仪器仪表，为中国的经济振兴和发展作出贡献。
							</div>
						</div>
						<div class="col-no" style="margin-left: 30px;justify-content: flex-end;">
							<img src="../../assets/img/khalImg2.png" />
						</div>
					</div>
				</div>			
			</div>
			
			
			<div class="mfty-box" style="background-color: #fff;height: 980px;">
				
				<div style="width: 1100px;margin: 0 auto;margin-top: 100px;">
					<div class="row" style="margin-top: 40px;padding-bottom: 80px;border-bottom: 1px #ccc solid;">					
						<div class="col-no" style="justify-content: flex-start;width: 400px;">
							<div class="row">
								<div class="item-no" style="height: 24px;width: 3px;background-color: #0070FD;"></div>
								<div class="item" style="margin-left: 8px;color: #0070FD;font-size: 24px;font-weight: bold;">
									项目实施
								</div>
							</div>
						</div>
						<div class="col">
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;text-align: left;">
								真诺测量仪表（上海）有限公司生产线，需要管理的设备贵重且精密，管理流程复杂，人工操作困难。贸宝信息技术软件结合客户的生产情况和设备规模，为其规划了一套科学规范的生产线设备解决方案，解决了米诺集团在设备管理上的难题，极大的提高了管理工作的效率。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								本次合作中，贸宝结合设备系统标准功能，在个别模块做适当调整，增加特种设备管理及统计分析报表。
							</div>
						</div>
					</div>
					<div class="row" style="margin-top: 40px;padding-bottom: 80px;">
						<div class="col-no" style="justify-content: flex-start;width: 400px;">
							<div class="row">
								<div class="item-no" style="height: 24px;width: 3px;background-color: #0070FD;"></div>
								<div class="item" style="margin-left: 8px;color: #0070FD;font-size: 24px;font-weight: bold;">
									收益分析
								</div>
							</div>
						</div>
						<div class="col">
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;text-align: left;">
								通过真诺测量仪表（上海）有限公司生产线设备管理的实施，公司的设备、特种设备台帐及养护管理，利用移动APP实现快速报修维修、巡检管理、保养管理，做到设备保养工作到位、有账可查、有数可分析的效果。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								规范配件仓储管理，配件条码化管理，移动终端扫码出入库、盘点，实现备件存取快速，降低备件损耗率。零部件安全库存预警，低于安全库存时，系统推送消息至负责人，并和在手机端查看详情。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								设备保养周期及内容自动提醒，提高维护精度。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								为其规划了一套科学规范的设备管理解决方案，解决了其在设备管理上的难题，极大的提高了管理工作的效率。
							</div>
						</div>
					</div>
				</div>			
			</div>
			
			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";

	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
				mouseIndex:-1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height
		},
		methods: {
			enter(index){
				this.mouseIndex=index
			},
			leave(){
				this.mouseIndex=-1
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return(() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		background: #f0f0f0;
		/* background: #f7f7f7; */
	}
	
	.center-body {
		margin: 0 auto;
	}
	
	.prduct-box {
		padding-top: 60px;
		width: 1200px;
		margin: 0 auto;
		position: relative;
	}
	.khal-tbox{
		height: 30px;
		background-color: #edf6ff;
		padding: 5px 15px;
		border-radius: 15px;
		color: #999;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}
	
</style>